import React, { useState } from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';

const TrendResearch = () => {
  const [activeBrand, setActiveBrand] = useState('CELSIUS');
  
  const formats = [
    { title: 'Audio Trends', items: ['Oh No - Capone', 'Aesthetic - Tollan', 'As It Was'], icon: 'Music' },
    { title: 'Challenges', items: ['GetReadyWithMe', 'DayInMyLife', 'ProductReview'], icon: 'Video' },
    { title: 'POV Formats', items: ['POV: You found...', 'POV: When someone...', 'POV: First time...'], icon: 'Eye' },
    { title: 'Memes', items: ['Drake Pointing', 'This or That', 'Nobody / Me'], icon: 'Smile' }
  ];

  const ideas = [
    { title: 'Pre-Workout POV', desc: 'POV: You set that 6 AM alarm...', tag: 'Relatable' },
    { title: 'Transformation Loop', desc: 'Before/After energy levels...', tag: 'Visual' },
    { title: 'Healthy Swaps', desc: 'Swapping soda for clean energy...', tag: 'Educational' },
    { title: 'Gym Motivation', desc: 'When the pre-workout hits...', tag: 'Humor' }
  ];

  return (
    <motion.div 
      initial={{ opacity: 0 }} 
      animate={{ opacity: 1 }}
      className="max-w-7xl mx-auto"
    >
      <h1 className="section-title">Trend Research Engine</h1>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-8">
        {formats.map((fmt, i) => (
          <motion.div 
            key={i}
            whileHover={{ y: -5 }}
            className="bg-white p-5 rounded-xl shadow-sm border border-gold/20"
          >
            <div className="w-10 h-10 bg-beige text-gold rounded-lg flex items-center justify-center mb-4">
              <SafeIcon name={fmt.icon} />
            </div>
            <h3 className="font-bold text-brown mb-3">{fmt.title}</h3>
            <ul className="space-y-2">
              {fmt.items.map((item, j) => (
                <li key={j} className="text-xs text-brown/60 bg-beige px-2 py-1 rounded">
                  {item}
                </li>
              ))}
            </ul>
          </motion.div>
        ))}
      </div>

      <div className="section-card">
        <div className="flex justify-between items-center mb-6">
          <h2 className="subsection-title mb-0">Brand Adaptations</h2>
          <select 
            value={activeBrand}
            onChange={(e) => setActiveBrand(e.target.value)}
            className="bg-beige border-none rounded-lg px-4 py-2 text-sm font-bold text-brown focus:ring-2 focus:ring-gold"
          >
            {['CELSIUS', 'OLIPOP', 'PBR'].map(b => <option key={b} value={b}>{b}</option>)}
          </select>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {ideas.map((idea, i) => (
            <motion.div 
              key={i}
              whileHover={{ scale: 1.01 }}
              className="bg-gradient-to-r from-beige to-white border border-gold/20 p-5 rounded-xl relative overflow-hidden group"
            >
              <div className="absolute top-0 right-0 bg-gold/20 text-brown text-[10px] font-bold px-2 py-1 rounded-bl-lg">
                {idea.tag}
              </div>
              <h3 className="font-bold text-lg text-brown mb-1">{idea.title}</h3>
              <p className="text-brown/70 text-sm">{idea.desc}</p>
              <button className="mt-4 text-xs font-bold text-gold opacity-0 group-hover:opacity-100 transition-opacity flex items-center">
                Use Template <SafeIcon name="ArrowRight" className="w-3 h-3 ml-1" />
              </button>
            </motion.div>
          ))}
        </div>
      </div>
    </motion.div>
  );
};

export default TrendResearch;